/*============================================================================
No Export Warning for High Value Orders
==============================================================================*/

const DEBUG = false;

// Add CSS styles
const style = document.createElement('style');
style.textContent = `
  .export-warning-disabled {
    opacity: 0.5 !important;
    cursor: not-allowed !important;
    pointer-events: none !important;
  }
  .export-warning-disabled:hover,
  .export-warning-disabled:focus,
  .export-warning-disabled:active {
    opacity: 0.5 !important;
    cursor: not-allowed !important;
    pointer-events: none !important;
  }
`;
document.head.appendChild(style);

(function() {
  // Configuration
  const CONFIG = {
    endpoints: {
      cart: "/cart.json",
      collection: "/collections/intern-kein-versand-in-ch-welt/products.json"
    },
    selectors: {
      // Cart selectors
      cartCheckoutBtns: '[name="checkout"], .checkout-button, .cart__checkout, .cart__submit, [href="/checkout"]',
      cartFooter: '.cart__footer--buttons, .drawer__footer-buttons',
      cartMessageWarning: ".cart-message-warnung",
      
      // Product page selectors 
      productForm: '.product-form:not([id*="quickview"])',
      addToCartButton: 'button[name="add"]',
      warningClass: 'product-export-warning',
      quickviewContainer: '[id*="quickview"], [class*="quickview"], [id*="quick-view"], [class*="quick-view"], [data-view-mode="quick-view"]'
    },
    messages: {
      productWarning: "Aus steuerlichen Gründen können wir dieses Produkt bei einem Bestellwert von über 1.000€ nicht in die Schweiz oder Länder außerhalb der EU exportieren. Bitte gib eine gesonderte Bestellung auf.",
      cartWarning: (productNames) => `Aus steuerlichen Gründen können wir ${productNames} bei einem Bestellwert von über 1.000€ nicht in die Schweiz oder Länder außerhalb der EU exportieren. Bitte gib eine gesonderte Bestellung auf.`
    },
    thresholds: {
      cartValue: 100000 // 1000€ in cents
    }
  };

  // State management
  const state = {
    isInitialized: false,
    isValidating: false,
    lastButtonState: null
  };

  // Debug logger
  const debug = {
    log(message, data = null) {
      if (DEBUG) {
        console.log(`[Export Warning Debug] ${message}`, data || '');
      }
    },
    error(message, error = null) {
      console.error(`[Export Warning Error] ${message}`, error || '');
    }
  };

  // Utility functions
  const utils = {
    isProductPage() {
      return window.location.pathname.includes("/products/");
    },
    
    async fetchJson(url) {
      try {
        debug.log(`Fetching: ${url}`);
        const response = await fetch(url);
        if (!response.ok) throw new Error(`HTTP error ${response.status}`);
        const data = await response.json();
        debug.log(`Fetch response:`, data);
        return data;
      } catch (error) {
        debug.error(`Error fetching ${url}:`, error);
        return null;
      }
    },
    
    getElements(selector) {
      return document.querySelectorAll(selector);
    },
    
    createElement(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text) element.textContent = text;
      return element;
    },
    
    insertAfter(newNode, referenceNode) {
      if (referenceNode?.parentNode) {
        referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
        return true;
      }
      return false;
    },
    
    getProductId() {
      // Try data attribute first
      const productInfo = document.querySelector('[data-product-id]');
      if (productInfo?.dataset.productId) {
        return parseInt(productInfo.dataset.productId, 10);
      }
      
      // Try hidden input
      const hiddenInput = document.querySelector('input[name="product-id"]');
      if (hiddenInput?.value) {
        return parseInt(hiddenInput.value, 10);
      }
      
      // Try meta tag
      const productMeta = document.querySelector('meta[property="product:id"]');
      if (productMeta?.content) {
        return parseInt(productMeta.content, 10);
      }
      
      return null;
    },

    isWorldMarket() {
      const marketMeta = document.querySelector('meta[name="market-handle"]');
      return marketMeta ? marketMeta.content === 'welt' : 
             window.location.hostname.includes('-welt') || 
             document.documentElement.getAttribute('data-market') === 'welt' ||
             window.Shopify?.locale?.market?.handle === 'welt';
    }
  };

  // Restricted Products Manager
  const restrictedProductsManager = {
    restrictedProductIds: null,
    
    async getRestrictedProductIds() {
      if (this.restrictedProductIds) {
        return this.restrictedProductIds;
      }
      
      const data = await utils.fetchJson(CONFIG.endpoints.collection);
      if (!data?.products || !Array.isArray(data.products)) {
        return new Set();
      }
      
      this.restrictedProductIds = new Set(data.products.map(product => product.id));
      return this.restrictedProductIds;
    },
    
    async isRestrictedProduct(productId) {
      if (!productId) return false;
      const id = typeof productId === 'string' ? parseInt(productId, 10) : productId;
      const restrictedProducts = await this.getRestrictedProductIds();
      return restrictedProducts.has(id);
    }
  };
  
  // Cart Manager
  const cartManager = {
    async getCartContents() {
      const cartData = await utils.fetchJson(CONFIG.endpoints.cart);
      
      if (!cartData?.items || cartData.items.length === 0) {
        return { hasRestrictedProducts: false, totalPrice: 0, restrictedProductNames: [] };
      }
      
      const restrictedProducts = await restrictedProductsManager.getRestrictedProductIds();
      const restrictedProductNames = [];
      
      for (const item of cartData.items) {
        if (restrictedProducts.has(item.product_id)) {
          restrictedProductNames.push(item.title.split(' - ')[0]);
        }
      }
      
      return { 
        hasRestrictedProducts: restrictedProductNames.length > 0, 
        totalPrice: cartData.total_price || 0,
        restrictedProductNames
      };
    },
    
    toggleCheckoutButtons(enabled) {
      utils.getElements(CONFIG.selectors.cartCheckoutBtns).forEach(button => {
        if (button.tagName === "A") {
          button.style.pointerEvents = enabled ? "" : "none";
          button.style.opacity = enabled ? "" : "0.5";
        } else {
          button.disabled = !enabled;
        }
      });
    },

    removeWarnings() {
      utils.getElements(CONFIG.selectors.cartMessageWarning).forEach(el => el.remove());
    },
    
    addWarningToCart() {
      this.removeWarnings();
      
      const warning = utils.createElement("div", 
        CONFIG.selectors.cartMessageWarning.substring(1),
        CONFIG.messages.cartWarning(this.lastRestrictedProducts.join(' und '))
      );
      
      utils.getElements(CONFIG.selectors.cartFooter).forEach(footer => {
        if (footer && !footer.querySelector(CONFIG.selectors.cartMessageWarning)) {
          footer.insertBefore(warning.cloneNode(true), footer.firstChild);
        }
      });
    },
    
    lastRestrictedProducts: [],
    
    async validateCart() {
      try {
        if (!utils.isWorldMarket()) return;
        
        const { hasRestrictedProducts, totalPrice, restrictedProductNames } = await this.getCartContents();
        const shouldWarn = hasRestrictedProducts && totalPrice >= CONFIG.thresholds.cartValue;
        
        if (shouldWarn) {
          this.lastRestrictedProducts = restrictedProductNames;
          this.addWarningToCart();
          this.toggleCheckoutButtons(false);
        } else {
          this.removeWarnings();
          this.toggleCheckoutButtons(true);
        }

        if (utils.isProductPage()) {
          productPageManager.validateProductPage();
        }
      } catch (error) {
        debug.error("Error validating cart:", error);
      }
    }
  };
  
  // Product Page Manager
  const productPageManager = {
    disableButton(button) {
      button.classList.add('export-warning-disabled');
      button.setAttribute('disabled', 'disabled');
      
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && 
              mutation.attributeName === 'disabled' && 
              !button.disabled && 
              button.classList.contains('export-warning-disabled')) {
            button.setAttribute('disabled', 'disabled');
          }
        });
      });
      
      observer.observe(button, {
        attributes: true,
        attributeFilter: ['disabled']
      });
      
      button._exportWarningObserver = observer;
    },

    enableButton(button) {
      if (button.classList.contains('export-warning-disabled')) {
        button.classList.remove('export-warning-disabled');
        button.removeAttribute('disabled');
        
        if (button._exportWarningObserver) {
          button._exportWarningObserver.disconnect();
          delete button._exportWarningObserver;
        }
      }
    },

    handleProductForms(forms, shouldWarn) {
      forms.forEach(form => {
        const addButton = form.querySelector(CONFIG.selectors.addToCartButton);
        if (!addButton) return;
        
        if (shouldWarn) {
          this.disableButton(addButton);
        } else {
          this.enableButton(addButton);
        }
        
        const existingWarning = form.querySelector('.' + CONFIG.selectors.warningClass);
        if (shouldWarn && !existingWarning) {
          const warning = utils.createElement('div', 
            CONFIG.selectors.warningClass + ' cart-message-warnung', 
            CONFIG.messages.productWarning
          );
          
          const buttonContainer = addButton.closest('.product-form__buttons') || addButton.parentNode;
          utils.insertAfter(warning, buttonContainer);
        } else if (!shouldWarn && existingWarning) {
          existingWarning.remove();
        }
      });
    },
    
    async validateProductPage() {
      try {
        if (!utils.isWorldMarket()) return;
        
        const productId = utils.getProductId();
        if (!productId) return;
        
        const isRestricted = await restrictedProductsManager.isRestrictedProduct(productId);
        const mainForms = utils.getElements(`:not(${CONFIG.selectors.quickviewContainer}) ${CONFIG.selectors.productForm}`);
        
        if (!isRestricted) {
          this.handleProductForms(mainForms, false);
          return;
        }
        
        const { totalPrice } = await cartManager.getCartContents();
        this.handleProductForms(mainForms, totalPrice >= CONFIG.thresholds.cartValue);
      } catch (error) {
        debug.error("Error validating product page:", error);
      }
    }
  };
  
  // Event Manager
  const eventManager = {
    cartEvents: ["cart:updated", "cart:refresh"],
    
    init() {
      debug.log('🚀 Initializing export warning script v1.3');
      
      this.cartEvents.forEach(event => {
        document.addEventListener(event, () => cartManager.validateCart());
      });
      
      document.addEventListener("drawer:handleAfterShow", e => {
        if (e.target.hasAttribute("cart-drawer")) {
          cartManager.validateCart();
        }
      });
      
      cartManager.validateCart();
      
      if (utils.isProductPage()) {
        const addButtons = document.querySelectorAll(CONFIG.selectors.addToCartButton);
        if (addButtons.length) {
          productPageManager.validateProductPage();
        } else {
          setTimeout(() => productPageManager.validateProductPage(), 500);
        }
      }
    }
  };
  
  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => eventManager.init());
  } else {
    eventManager.init();
  }
})(); 